/** @jsx CanvaSX */
import wireframeLink from '../assets/icons/wireframeLink.svg';
import WireframeButton from './WireframeButton';

class WireframeLink extends WireframeButton {
  initItems() {
    if (!this.placeholder?.value) {
      this.addPlaceholder({ value: 'Link', state: 'default' });
    }
  }

  static iconSvg() {
    return wireframeLink;
  }

  static externalName(): string {
    return 'Link';
  }
}

export default WireframeLink;
